<template>
  <div class="modern-registration-app">
    <!-- 現代化通知 Toast -->
    <transition name="slide-down">
      <div v-if="showTop" class="modern-notification" :class="[mstype]">
        <div class="notification-content">
          <div class="loading-icon" v-if="mstype === 'primary'">
            <div class="spinner"></div>
          </div>
          <div class="success-icon" v-if="mstype === 'success'">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
              <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.061L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"/>
            </svg>
          </div>
          <span class="notification-text">{{ msg }}</span>
        </div>
      </div>
    </transition>

    <div v-if="JSON.stringify(obj)!=='{}'" class="registration-wrapper" >
      <form ref="myForm" @submit.prevent="applyForm" class="modern-form">
        
        <!-- 活動頭部卡片 -->
        <div class="activity-hero-card">
          <div class="hero-image-container">
            <img 
              :src="obj.acts_mact && obj.acts_mact.url ? obj.acts_mact.url : catImg('event_1080x540.png')" 
              alt="活動圖片"
              class="hero-image"
            />
            <div class="hero-overlay">
              <div class="hero-content">
                <h1 class="activity-title">{{ obj.acts_mact.actitle }}</h1>
                <div class="registration-badge">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
                  </svg>
                  活動報名表
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 活動資訊卡片 -->
        <div class="activity-info-section">
          <div class="section-title">
            <h2>活動資訊</h2>
            <p>了解活動詳細資訊</p>
          </div>
          
          <div class="info-cards-grid">
            <div class="info-card">
              <div class="info-icon time-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"/>
                  <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z"/>
                </svg>
              </div>
              <div class="info-content">
                <h3>活動時間</h3>
                <p>{{ obj.acts_mact.sdate }} {{ obj.acts_mact.stime.substring(0, 5) }} ~ {{ obj.acts_mact.edate==obj.acts_mact.sdate?'':obj.acts_mact.edate }} {{ obj.acts_mact.etime.substring(0, 5) }}</p>
              </div>
            </div>

            <div class="info-card">
              <div class="info-icon location-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"/>
                </svg>
              </div>
              <div class="info-content">
                <h3>活動地點</h3>
                <p>{{ obj.acts_mact.address }}</p>
              </div>
            </div>

            <div class="info-card" v-if="obj.acts_mact.checked">
              <div class="info-icon people-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
                  <path fill-rule="evenodd" d="M5.216 14A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216z"/>
                  <path d="M4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"/>
                </svg>
              </div>
              <div class="info-content">
                <h3>報名人數限制</h3>
                <p>限制報名人數：{{ obj.acts_mact.value }}</p>
              </div>
            </div>
          </div>

          <!-- 全選功能 -->
          <div class="select-all-section" v-if="obj.acts_mact.checked==false">
            <label class="modern-checkbox-label">
              <input type="checkbox" @change="onChange" class="modern-checkbox-input">
              <span class="modern-checkbox-custom"></span>
              <span class="checkbox-text">全選/取消所有可選日期</span>
            </label>
          </div>
        </div>              
        <!-- 日曆選擇區域 -->
        <div class="calendar-selection-section">
          <div class="section-title">
            <h2>選擇活動日期</h2>
            <p>請在日曆中選擇您要參加的活動日期</p>
          </div>
          
          <div class="calendar-wrapper">
            <a-calendar @select="onSelect" :defaultValue="currentTime" :locale="locale" :disabledDate="disabledDate" :fullscreen="true">
              <div slot="dateCellRender" slot-scope="value" class="events" style="overflow-x: hidden;overflow-y:hidden;">
                <div v-for="item  in getListData(value)" :key="item.id">
                  <div 
                    class="notes" 
                    :style="{
                      'background-image': item.type === 'Y' 
                        ? 'linear-gradient(to bottom, #c5ddf8, #3386e7)' 
                        : 'linear-gradient(to bottom, #dbdedb, #aeb1ae)',
                      'cursor': 'pointer'
                    }"
                  >
                    <p style="margin-top: 0.5rem; color: aliceblue; font-size: 1rem; font-weight: bold;">
                      {{ item.type === 'Y' ? '請選擇' : '不能選' }}
                    </p>
                  </div>
                </div>
              </div>
              <template slot="monthCellRender" slot-scope="value">
                <div v-if="getMonthData(value)" class="notes-month">
                  <section>{{ getMonthData(value) }}</section>
                  <span>Backlog number</span>
                </div>
              </template>
            </a-calendar>
          </div>
        </div>

        <!-- 已選日期顯示 -->
        <div v-if="selectitem.length > 0" class="selected-dates-section">
          <div class="section-title">
            <h2>已選擇的日期</h2>
            <p>您已選擇 {{ selectitem.length }} 個活動日期</p>
          </div>
          
          <div class="selected-dates-container">
            <div v-for="item in selectitem" :key="item.id" class="selected-date-card">
              <div class="date-info">
                <div class="date-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>
                  </svg>
                </div>
                <span class="date-text">{{ getdate(item.sdate) }}</span>
              </div>
              <button @click="removes(item.id)" class="remove-date-btn" type="button">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
                </svg>
              </button>
            </div>
          </div>
        </div>

        <!-- 額滿課程提示 -->
        <div v-if="selectitem.length==0 && others.length>0" class="full-courses-alert">
          <div class="alert-header">
            <div class="alert-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
                <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
              </svg>
            </div>
            <h3>課程狀態通知</h3>
          </div>
          <div class="full-courses-list">
            <div v-for="item in others" :key="item.id" class="full-course-item">
              <span class="course-date">{{ getdate(item.sdate) }}</span>
              <span class="course-status">該課程已額滿</span>
            </div>
          </div>
        </div>

        <!-- 報名表單區域 -->
        <div v-if="list1.length>0" class="registration-form-section">
          <div class="section-title">
            <h2>報名資訊</h2>
            <p>請完整填寫以下報名資訊</p>
          </div>

          <!-- 費用選擇 -->
          <div v-if="obj.acts_mact.fee" class="fee-selection-card">
            <div class="fee-header">
              <div class="fee-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M4 10.781c.148 1.667 1.513 2.85 3.591 3.003V15h1.043v-1.216c2.27-.179 3.678-1.438 3.678-3.3 0-1.59-.947-2.51-2.956-3.028l-.722-.187V3.467c1.122.11 1.879.714 2.07 1.616h1.47c-.166-1.6-1.54-2.748-3.54-2.875V1H7.591v1.233c-1.939.23-3.27 1.472-3.27 3.156 0 1.454.966 2.483 2.661 2.917l.61.162v4.031c-1.149-.17-1.94-.8-2.131-1.718H4zm3.391-3.836c-1.043-.263-1.6-.825-1.6-1.616 0-.944.704-1.641 1.8-1.828v3.495l-.2-.05zm1.591 1.872c1.287.323 1.852.859 1.852 1.769 0 1.097-.826 1.828-2.2 1.939V8.73l.348.086z"/>
                </svg>
              </div>
              <div>
                <h3>活動參加費用</h3>
                <span class="required-mark">* 必選</span>
              </div>
            </div>
            
            <div class="fee-options-grid">
              <label v-for="items in obj.acts_mact.items" :key="items.id" class="fee-option-card">
                <input v-model="selecteds" name="customRadioInline1" type="radio" :value="items.id" required class="fee-radio-input"/>
                <div class="fee-option-content">
                  <div class="fee-amount">{{ items.fee }} TWD</div>
                  <div class="fee-title">{{ items.title }}</div>
                </div>
                <div class="radio-indicator"></div>
              </label>
            </div>
          </div>

          <!-- 表單欄位 -->
          <div class="form-fields-container">
            <div v-for="element in list1" :key="element.id" class="form-field-card">
              <!-- 文字輸入欄位 -->
              <div v-if="element.input=='text' || element.input=='email' || element.input=='tel' || element.input=='date' || element.input=='file'" class="text-input-field">
                <label class="field-label">
                  {{ element.name }}
                  <span v-if="element.required" class="required-mark">*</span>
                </label>
                <div class="input-wrapper">
                  <input 
                    v-model="element.val" 
                    :readonly="element.name === '帳號'" 
                    :type="element.input" 
                    class="modern-text-input" 
                    autocomplete="off" 
                    :required="element.required" 
                    :placeholder="element.placeholder"
                  />
                </div>
              </div>

              <!-- 單選/多選欄位 -->
              <div v-if="element.input=='radio' || element.input=='checkbox'" class="choice-field">
                <label class="field-label">
                  {{ element.name }}
                  <span v-if="element.required" class="required-mark">*</span>
                </label>
                <div class="choice-options-grid">
                  <label v-for="obj in element.list" :key="obj.value" class="choice-option-card">
                    <input 
                      v-if="element.input=='radio'" 
                      v-model="element.val" 
                      :name="`radio-${element.id}`" 
                      :type="element.input" 
                      :value="obj.value"
                      class="choice-input"
                    />
                    <input 
                      v-if="element.input=='checkbox'" 
                      v-model="element.ary[obj.value]" 
                      :name="element.id" 
                      :type="element.input" 
                      :value="obj.value"
                      class="choice-input"
                    />
                    <span class="choice-label">{{ obj.text }}</span>
                  </label>
                </div>
              </div>

              <!-- 下拉選單欄位 -->
              <div v-if="element.input=='select'" class="select-field">
                <label class="field-label">
                  {{ element.name }}
                  <span v-if="element.required" class="required-mark">*</span>
                </label>
                <div class="select-wrapper">
                  <select v-model="element.val" class="modern-select-input">
                    <option value="">--請選擇--</option>
                    <option v-for="obj in element.list" :key="obj.value" :value="obj.value">
                      {{ obj.text }}
                    </option>
                  </select>
                  <div class="select-arrow">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                      <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 提交按鈕 -->
        <div class="submit-section">
          <button type="submit" class="modern-submit-btn" :disabled="disables">
            <div v-if="disables" class="submit-loading">
              <div class="submit-spinner"></div>
              <span>處理中...</span>
            </div>
            <div v-else class="submit-content">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"/>
              </svg>
              <span>立即報名</span>
            </div>
          </button>
        </div>

      </form>
    </div>
  </div>
</template>

<script>
import {mapState,mapActions} from 'vuex';
import { joinService } from '../../_services'
//import { checktokens } from "../../api/utils";
import 'moment/locale/zh-tw';
import * as moment from "moment/moment";
import Formdata from '../../assets/json/formdata.json'
import router from '../../router'

const postdata = obj => {
  return  joinService.postform(obj)
}
const postpay = obj =>(joinService.postpay(obj))


export default {
  name: "Regapply",
  props: {
    obj: Object, 
    kinds : String,
  },
  data() {
    return {     
      xurl: "",
      disables:false,
      showTop: false, 
      tpay:false, //20220922 中斷付費功能
      currentTime:moment(),
      msg:"資料正在送出....",
      mstype:"",
      selectitem:[],
      myJson: [], 
      arryitems:[], 
      information:[],          
      list1: [],
      others:[],
      selecteds:null,   
      iconLoading: false,   
      imgs: {
        width: 0,
        height: 0
      },
      locale:{
        lang:{
          month:'月',
          year:'年',
        }
      },      

    };
  },
  computed: {
    ...mapState("account", ["status", "user"]),
  },
  methods: {
    ...mapActions("account", ["checktoken", "logout"]),
    
    async applyForm() {

      if(this.selectitem.length==0){  
        this.$message.error('您尚未選擇活動課程，謝謝');      
        /*if(this.obj.acts_mact.checked){
          this.$message.error('已達報名人數限制，無法接受報名，謝謝');
        }else{
          this.$message.error('報名時間已逾期，不接受報名． 謝謝');
        }*/
        return false
      }
      let items =[]         
      let usernames=''
      this.others =[]
      for(var obj in this.list1){

        if (this.list1[obj].input === 'radio' && !this.list1[obj].val) {
              this.$message.error(`請選擇 ${this.list1[obj].name}`);
              return false;
        }

        if (this.list1[obj].input === 'checkbox') {
          const isChecked = Object.values(this.list1[obj].ary).some((value) => value === true);
          if (!isChecked) {
            this.$message.error(`請至少選擇一個 ${this.list1[obj].name}`);
            return false;
          }
        }

        if (this.list1[obj].input === 'select' && (!this.list1[obj].val || this.list1[obj].val === '')) {
          this.$message.error(`請選擇 ${this.list1[obj].name}`);
          return false;
        }        
        
        if(this.list1[obj].id==1){
          usernames= this.list1[obj].val
        }
        if(this.list1[obj].input==='checkbox')
        {     
          let tmp = Object.entries(this.list1[obj].ary)
          for(var rs in tmp){
            if(tmp[rs][1]==true){                          
              items.push({
                oid: this.list1[obj].id,
                items:tmp[rs][0].toString()
              }) 
            }
          }       
        }else{
          items.push({
                oid: this.list1[obj].id,
                items:this.list1[obj].val.toString()
              }) 
        }
      }
      this.showTop = true;
      this.disables=true
      this.mstype="primary"

      let check = 'Y'
      if(this.obj.acts_mact.fee && this.selecteds!==""){
        check='N'
      }
      let tmps=[];
      for(var i in this.selectitem){
          tmps.push({
            id : '',
            uid :  this.user.data.user.id,     //申請者
            aid :  this.selectitem[i].id,    //課程檔 id
            sdate : this.selectitem[i].sdate ,   // 舉辦日期
            edate : this.selectitem[i].edate ,   // 結束日期
            states: 'N' ,   // 狀態
            roles : 'actor',    // 活動角色
            score : this.obj.acts_mact.actor,   //參加分數
            byrsoptions : items //報名表            
          })
      } 

      let playload ={
        id:this.obj.acts_joinform.fid==0?0:this.obj.acts_joinform.id,
        fid:this.obj.acts_mact.id,
        uid:this.user.data.user.id,
        Sdate:this.obj.acts_mact.sdate +" "+this.obj.acts_mact.stime,
        Edate:this.obj.acts_mact.edate +" "+this.obj.acts_mact.etime,
        roles:'actor',
        states:check,
        myrsoptions:items,
        acts_detrimal:tmps,
        wchecked:this.obj.acts_mact.Checked,
        value:this.obj.acts_mact.value
      }
      //console.log("playload:",playload)
      postdata(playload).then(({data,other}) =>{
              //this.$message.success('新增資料成功',2);
              //if(data.id!==undefined){ 
              console.log(data,other);
              if(data!==undefined && data !==null){
                this.msg = "報名資料已送出, 謝謝您的報名!"
                this.mstype="success"
                setTimeout(() => {   
                    this.showTop = false;
                    this.disables = false;
                    this.inidata()
                    if(this.obj.acts_mact.fee && this.selecteds!=="" && this.tpay){
                      let rsitem = this.obj.acts_mact.items.filter((el)=>{return el.id ===this.selecteds})
                      let tmp={
                          fid:data.id,mid:this.obj.acts_mact.id,
                          uid:this.user.data.user.id,
                          kinds: this.kinds,
                          orderusername:usernames,
                          ordertitle:this.obj.acts_mact.actitle,
                          orderids:this.selecteds,                          
                          orderitem:rsitem[0].title,
                          orderdesc:rsitem[0].desc,
                          orderamount: rsitem[0].fee.toString()                         
                      }
                      postpay(tmp).then((rsponse)=>{
                        tmp = this.decodeHtml(rsponse)
                        var htmlObject = document.createElement('div');
                        htmlObject.innerHTML = tmp;  
                        document.write(htmlObject.innerHTML);                        

                      })                     
                    }else{
                      this.selectitem=[]
                      this.$emit('reload')
                      if(other!==null){
                        this.others = other
                      }else{
                        if(this.kinds=='N'){
                          router.replace('/').catch(err=>{err})
                        }else{
                          router.replace({ name: 'Myline'}).catch(err=>{err})
                        }
                      }
                    }

                    clearInterval();
                }, 3000);  
            }else{
              setTimeout(() => {
                this.showTop = false;
                this.disables = false;
                this.selectitem=[]
                this.$emit('reload')
                if(other!==null){
                  this.others = other
                }
                }, 3000);		
            }                      
      });      


    }, 
    
    onChange(e){
      if(e.target.checked==true){
        let item = this.obj.acts_mact.acts_actclass
        for (let i = 0; i < item.length; i++) {
          if(item[i].checked && (item[i].totail==item[i].value)){
            continue;
          }
          if(this.getformat(item[i].edate) > this.getformat(this.currentTime)){
            if(this.obj.acts_joinform.acts_detrimal!==null){
              let tmp = this.obj.acts_joinform.acts_detrimal.filter(rs=>rs.aid==item[i].id)
              if(tmp.length==0 && this.oncheck(item[i].id).length==0){
                this.selectitem.push(item[i]);
              }
            }else{
              if(this.oncheck(item[i].id).length==0){
                this.selectitem.push(item[i]);
              }
            }
          }
        }
      }else{
        this.selectitem =[]
      }

    },

    getListData(value) {
      let listData=[];
      if(this.obj.acts_mact.acts_actclass!==null){ 
      this.obj.acts_mact.acts_actclass.forEach((item)=>{          
          if(moment(item.sdate).format('YYYY-MM-DD') == value.format("YYYY-MM-DD")){
              let state = moment(item.edate).format('YYYY-MM-DD HH:mm') >=this.currentTime.format("YYYY-MM-DD HH:mm")?'Y':'N'              
              if(state=='Y' && this.obj.acts_joinform.acts_detrimal!==null){
                state = this.obj.acts_joinform.acts_detrimal.filter(rs=>rs.aid==item.id).length>0?'N':'Y'
              }
              if(this.obj.acts_mact.checked){
                  let tmp = this.obj.acts_mact.acts_actclass.filter(rs=>rs.id==item.id)
                  if(tmp.length>0){
                    if(tmp[0].totail==tmp[0].value){
                      state ='N'
                    }
                  } 
                }                  
              listData.push(
                  {
                    type:  state,
                    id:item.id,
                    fid:item.fid,          
                    orgid:item.orgid,       
                    url:item.url,           
                    actitle:item.actitle,          
                    sdate:item.sdate,         
                    edate:item.edate,                     
                    state:item.status                                                                                           
                }
              )
          }            
          });
          return listData || [];
      }
      return listData || [];

    }, 
    
    disabledDate(value){
      if(this.obj.acts_mact.acts_actclass!==null){ 
        let state = ''
      this.obj.acts_mact.acts_actclass.forEach((item)=>{ 
          if(moment(item.sdate).format('YYYY-MM-DD') == value.format("YYYY-MM-DD")){
              state = moment(item.edate).format('YYYY-MM-DD HH:mm') >=this.currentTime.format("YYYY-MM-DD HH:mm")?'Y':'N'              
              if(state=='Y' && this.obj.acts_joinform.acts_detrimal!==null){
                state = this.obj.acts_joinform.acts_detrimal.filter(rs=>rs.aid==item.id).length>0?'N':'Y'
              }
              if(this.obj.acts_mact==undefined){
                return
              }
              if(this.obj.acts_mact.checked){
                  let tmp = this.obj.acts_mact.acts_actclass.filter(rs=>rs.id==item.id)
                  if(tmp.length>0){
                    if(tmp[0].totail==tmp[0].value){
                      state ='N'
                    }
                  } 
              } 
              return 
          }       
          });
          return state=='N'? true:false   
      }
    },     
    getformat(val){
        return moment(val).format("YYYY-MM-DD HH:mm"); 
    },      
    
   async onSelect(e){
      let tmp = this.getdate(e._d);
      this.others=[]
        let obj = this.obj.acts_mact.acts_actclass.filter(rs=>moment(rs.sdate).format("YYYY-MM-DD")==tmp)
        if(obj.length>0){
            if(obj[0].checked && (obj[0].totail==obj[0].value)){
            return false
          }
        }
        if(this.obj.acts_mact.checked){          
          let results = await this.checkJoin(obj[0].id)
          if(obj[0].totail <= results.data){
            this.$message.error('該課程報名額滿 :' + results.data);    
            return false
          }
        }       

        if(obj.length>0 && this.getformat(obj[0].edate) > this.getformat(this.currentTime)){          
          if(this.obj.acts_joinform.acts_detrimal!==null){
            let tmp = this.obj.acts_joinform.acts_detrimal.filter(rs=>rs.aid==obj[0].id)
            if(tmp.length==0 && this.oncheck(obj[0].id).length==0){
              this.selectitem.push(obj[0]);
            }
          }else{
            if(this.oncheck(obj[0].id).length==0){
              this.selectitem.push(obj[0]);
            }
          }
        }        
    },

    oncheck(val){
      return this.selectitem.filter(rs=>rs.id==val)
    },
    
    getdate(val){
        return moment(val).format("YYYY-MM-DD"); 
    },    
    
    decodeHtml(html) {
        var txt = document.createElement("textarea");
        txt.innerHTML = html;
        return txt.value;
    },      

    catImg(imgs) {
      // 使用靜態圖片映射來避免動態 require 問題
      const imageMap = {
        'event_1080x540.png': require('../../assets/event_1080x540.png'),
        'event_540.png': require('../../assets/event_540.png'),
        'actimg.png': require('../../assets/actimg.png'),
        'logo.png': require('../../assets/logo.png'),
        'aclogo.png': require('../../assets/aclogo.png'),
        'bg_1080x540.png': require('../../assets/bg_1080x540.png'),
        // 可以根據需要添加更多圖片
      };
      
      return imageMap[imgs] || require('../../assets/event_1080x540.png'); // 預設圖片
    },

    removes(val) {
      this.selectitem = this.selectitem.filter(rs=>rs.id!=val)
    },
      

    async inidata(){  
        this.list1=[]  
        
        // 檢查 this.db 和 this.obj.acts_mact 是否有效
        if (!this.obj.acts_mact || !this.obj.acts_mact.options) {
            console.warn('fiData 或 fiData.options 不存在');
            return;
        }
        
        // 判斷是否有 db 資料且 acts_detrimal 存在且不為空
        const hasValidDbData = this.obj && 
                              this.obj.acts_joinform.acts_detrimal && 
                              Array.isArray(this.obj.acts_joinform.acts_detrimal) && 
                              this.obj.acts_joinform.acts_detrimal.length > 0;
        
		if (!hasValidDbData) {
			// 如果沒有有效的 db 資料，使用預設值
			for(const option of this.obj.acts_mact.options){
				const formElement = this.myJson.find(el => el.id === option.oid);
				if (!formElement) continue;
				
				const rs = { ...formElement };
				
				// 特殊處理：帳號、電話、email 使用使用者資料
				if(rs.id == 1){
					rs.val = this.user.data.user.username
				}else if(rs.id == 2){
					rs.val = this.user.data.user.hphone !== undefined ? this.user.data.user.hphone : '' 
				}else if(rs.id == 3){
					rs.val = this.user.data.user.email
				}
				// checkbox 類型：初始化為空物件
				else if([8, 19].includes(rs.id)){
					rs.ary = {} 
				}
				// text、radio、select 類型：初始化為空字串
				else if([4, 5, 6, 7, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 20, 21].includes(rs.id)){
					rs.val = ""
				}
				
				this.list1.push(rs);
			}           
		} else {
            // 有有效的 db 資料，從 byrsoptions 中獲取值
            try {
                const latestDetrimal = this.obj.acts_joinform.acts_detrimal[this.obj.acts_joinform.acts_detrimal.length - 1];
                const byrsoptions = latestDetrimal?.byrsoptions || [];
                
                for(const option of this.obj.acts_mact.options){
                    const formElement = this.myJson.find(el => el.id === option.oid);
                    if (!formElement) continue;
                    
                    const rs = { ...formElement };
                    
                    // 根據不同的欄位類型設定值
                    if([1,2,3,4,5,10,13,14,17,20,21].includes(rs.id)){
                        // 從 byrsoptions 中獲取對應的 items（單一值）
                        const matchedOption = byrsoptions.find(opt => opt.oid === rs.id);
                        rs.val = matchedOption ? matchedOption.items : "";
                    } else if([6,9,16].includes(rs.id)){
                        // 處理 radio 類型的欄位
                        if(rs.input === 'radio') {
                            const matchedOption = byrsoptions.find(opt => opt.oid === rs.id);
                            rs.val = matchedOption ? matchedOption.items : "";
                        } else {
                            // 非 radio 類型，取第一個匹配的值
                            const matchedOption = byrsoptions.find(opt => opt.oid === rs.id);
                            rs.val = matchedOption ? matchedOption.items : "";
                        }
                    } else if([7,11,12,15,18].includes(rs.id)){
                        // 處理 select 類型的欄位
                        if(rs.input === 'select') {
                            const matchedOption = byrsoptions.find(opt => opt.oid === rs.id);
                            rs.val = matchedOption ? matchedOption.items : "";
                        } else {
                            // 非 select 類型，初始化為空物件（可能是 checkbox 或其他）
                            rs.ary = {};
                        }
                    } else if([8,19].includes(rs.id)){
                        // 處理 checkbox 類型的欄位
                        if(rs.input === 'checkbox') {
                            rs.ary = {};
                            // 從 byrsoptions 中找出所有對應 oid 的項目
                            const matchedOptions = byrsoptions.filter(opt => opt.oid === rs.id);
                            
                            // 將匹配的項目設定為 true
                            matchedOptions.forEach(opt => {
                                rs.ary[opt.items] = true;
                            });
                        } else {
                            // 非 checkbox 類型，取第一個匹配的值
                            const matchedOption = byrsoptions.find(opt => opt.oid === rs.id);
                            rs.val = matchedOption ? matchedOption.items : "";
                        }
                    } else {
                        rs.val = "";
                    }
                    this.list1.push(rs);
                }
            } catch (error) {
                console.error('處理 byrsoptions 時發生錯誤:', error);
                // 發生錯誤時回退到預設處理
                //this.inidata();
                return;
            }
        }           
    },

    checkJoin(id) {
      return new Promise((resolve) => {
        resolve(joinService.queryJoin(id.toString()));
      });
    }
  

  },
  mounted () {
    this.inidata()
    // 志工或講師身分提示
    this.$nextTick(() => {
      const role = this.obj.acts_joinform && this.obj.acts_joinform.roles;
      if (role === 'volunteer' || role === 'coach') {
        const h = this.$createElement;
        this.$notification.warning({
          message: h('span', { style: { fontSize: '16px', fontWeight: 'bold', color: '#d46b08' } }, '🎗️ 您目前的身分為 志工 / 講師'),
          description: h('div', { style: { marginTop: '6px' } }, [
            h('p', { style: { margin: '0 0 8px 0', lineHeight: '1.7', color: '#595959' } }, ' 身分提醒'),
            h('p', { style: { margin: '0 0 8px 0', background: '#fffbe6', border: '1px solid #ffe58f', borderRadius: '6px', padding: '8px 12px', color: '#613400', lineHeight: '1.7' } }, [
              h('span', null, '📌 在 '),
              h('strong', null, '尚未開課'),
              h('span', null, ' 的課程中，若顯示「'),
              h('strong', { style: { color: '#cf1322' } }, '不能選'),
              h('span', null, '」的課程，代表系統已預先為你完成報名，'),
              h('strong', null, '無需再次報名'),
              h('span', null, '。'),
            ]),
          ]),
          duration: 0,
          style: {
            width: '420px',
            borderLeft: '4px solid #fa8c16',
            boxShadow: '0 4px 16px rgba(250,140,22,0.2)',
          },
        });
      }
    });    
    //console.log("mounted:",this.list1)
  },
  created() {    
    this.myJson = Formdata  
    //console.log("created:",this.list1)
  },
  beforeDestroy() {}
};
</script>
<style scoped>
/* === 主要應用容器 === */
.modern-registration-app {
  width: 100%;
  max-width: 100%;
  background: white !important;
  padding: 0;
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif;
  color-scheme: light;
  box-sizing: border-box;
  overflow-x: hidden;
}

/* === 現代化通知系統 === */
.modern-notification {
  position: fixed;
  top: 30px;
  right: 30px;
  z-index: 9999;
  padding: 20px 28px;
  border-radius: 16px;
  backdrop-filter: blur(20px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  color: white;
  font-weight: 600;
  min-width: 350px;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.modern-notification.primary {
  background: linear-gradient(135deg, rgba(251, 251, 251, 0.95), rgba(243, 244, 246, 0.95));
  color: #374151;
  border: 1px solid rgba(209, 213, 219, 0.5);
}

.modern-notification.success {
  background: linear-gradient(135deg, rgba(167, 243, 208, 0.95), rgba(52, 211, 153, 0.95));
}

.notification-content {
  display: flex;
  align-items: center;
  gap: 16px;
}

.spinner {
  width: 24px;
  height: 24px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top: 2px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.success-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}

.notification-text {
  font-size: 16px;
  line-height: 1.4;
}

/* === 動畫效果 === */
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.slide-down-enter-active, .slide-down-leave-active {
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.slide-down-enter, .slide-down-leave-to {
  transform: translateY(-100%) translateX(50px);
  opacity: 0;
}

/* === 主要容器 === */
.registration-wrapper {
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.modern-form {
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;
  max-width: 100%;
  padding: 20px;
  box-sizing: border-box;
}

/* === 活動英雄區域 === */
.activity-hero-card {
  width: 100%;
  max-width: 100%;
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  background: white !important;
  box-sizing: border-box;
}

.hero-image-container {
  position: relative;
  height: 400px;
  overflow: hidden;
}

.hero-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.6s ease;
}

.hero-image:hover {
  transform: scale(1.05);
}

.hero-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.85));
  padding: 40px;
}

.hero-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.activity-title {
  margin: 0;
  font-size: 3rem;
  font-weight: 800;
  color: white;
  text-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  line-height: 1.2;
}

.registration-badge {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  color: white;
  padding: 12px 20px;
  border-radius: 50px;
  font-weight: 600;
  font-size: 16px;
  width: fit-content;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

/* === 區段標題 === */
.section-title {
  text-align: center;
  margin-bottom: 32px;
}

.section-title h2 {
  margin: 0 0 8px 0;
  font-size: 2.5rem;
  font-weight: 700;
  color: #1f2937;
  background: linear-gradient(135deg, #6b7280, #374151, #111827);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.section-title p {
  margin: 0;
  color: #6b7280;
  font-size: 1.1rem;
  font-weight: 500;
}

/* === 活動資訊區域 === */
.activity-info-section {
  width: 100%;
  max-width: 100%;
  background: white !important;
  border-radius: 24px;
  padding: 40px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
}

.info-cards-grid {
  display: grid;
  gap: 24px;
  margin-bottom: 32px;
}

@media (min-width: 768px) {
  .info-cards-grid {
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  }
}

.info-card {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 16px;
  background: linear-gradient(135deg, #fefefe, #f9f7f8);
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.info-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);
  border-color: #cbd5e1;
}

.info-icon {
  flex-shrink: 0;
  width: 56px;
  height: 56px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.time-icon {
  background: linear-gradient(135deg, #10b981, #059669);
}

.location-icon {
  background: linear-gradient(135deg, #a5b4fc, #818cf8);
}

.people-icon {
  background: linear-gradient(135deg, #fbbf24, #f59e0b);
}

.info-content h3 {
  margin: 0 0 8px 0;
  font-size: 1.3rem;
  font-weight: 700;
  color: #1f2937;
}

.info-content p {
  margin: 0;
  color: #4b5563;
  line-height: 1.6;
  font-size: 1rem;
}

/* === 全選功能 === */
.select-all-section {
  padding-top: 32px;
  border-top: 2px solid #f5f1f3;
}

.modern-checkbox-label {
  display: flex;
  align-items: center;
  gap: 16px;
  cursor: pointer;
  font-size: 1.1rem;
  font-weight: 600;
  color: #374151;
  justify-content: center;
}

.modern-checkbox-input {
  display: none;
}

.modern-checkbox-custom {
  width: 24px;
  height: 24px;
  border: 2px solid #d1d5db;
  border-radius: 6px;
  position: relative;
  transition: all 0.3s ease;
  background: white;
}

.modern-checkbox-input:checked + .modern-checkbox-custom {
  background: linear-gradient(135deg, #10b981, #059669);
  border-color: #059669;
}

.modern-checkbox-input:checked + .modern-checkbox-custom::after {
  content: '✓';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 14px;
  font-weight: bold;
}

/* === 日曆區域 === */
.calendar-selection-section {
  width: 100%;
  max-width: 100%;
  background: white !important;
  border-radius: 24px;
  padding: 40px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
}

.calendar-wrapper {
  width: 100%;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
}

/* === 已選日期 === */
.selected-dates-section {
  width: 100%;
  max-width: 100%;
  background: white !important;
  border-radius: 24px;
  padding: 40px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
}

.selected-dates-container {
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
}

.selected-date-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  background: linear-gradient(135deg, #10b981, #059669);
  color: white;
  border-radius: 16px;
  box-shadow: 0 8px 20px rgba(16, 185, 129, 0.3);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.selected-date-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 16px 32px rgba(16, 185, 129, 0.4);
}

.date-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.date-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}

.date-text {
  font-weight: 700;
  font-size: 1.2rem;
}

.remove-date-btn {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.remove-date-btn:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.1);
}

/* === 額滿課程警告 === */
.full-courses-alert {
  width: 100%;
  max-width: 100%;
  background: white !important;
  border-radius: 24px;
  padding: 40px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  border-left: 6px solid #f59e0b;
  box-sizing: border-box;
}

.alert-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
}

.alert-icon {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #f59e0b, #d97706);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.alert-header h3 {
  margin: 0;
  color: #f59e0b;
  font-size: 1.5rem;
  font-weight: 700;
}

.full-courses-list {
  display: grid;
  gap: 12px;
}

.full-course-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: #fef3c7;
  border: 1px solid #fde68a;
  border-radius: 12px;
  color: #92400e;
  font-weight: 600;
}

.course-date {
  font-weight: 700;
}

.course-status {
  color: #dc2626;
}

/* === 報名表單區域 === */
.registration-form-section {
  width: 100%;
  max-width: 100%;
  background: white !important;
  border-radius: 24px;
  padding: 40px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
}

/* === 費用選擇 === */
.fee-selection-card {
  background: linear-gradient(135deg, #f9fafb, #f3f4f6);
  border: 2px solid #e5e7eb;
  border-radius: 20px;
  padding: 24px;
  margin-bottom: 40px;
}

.fee-header {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 24px;
}

.fee-icon {
  width: 56px;
  height: 56px;
  background: linear-gradient(135deg, #6b7280, #4b5563);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.fee-header h3 {
  margin: 0;
  color: #374151;
  font-size: 1.5rem;
  font-weight: 700;
}

.required-mark {
  color: #dc2626;
  font-weight: 700;
  font-size: 0.9rem;
}

.fee-options-grid {
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
}

.fee-option-card {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  background: white;
  border: 2px solid #e5e7eb;
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.fee-option-card:hover {
  border-color: #10b981;
  box-shadow: 0 8px 16px rgba(16, 185, 129, 0.2);
  transform: translateY(-2px);
}

.fee-radio-input {
  display: none;
}

.fee-radio-input:checked + .fee-option-content + .radio-indicator {
  background: linear-gradient(135deg, #10b981, #059669);
}

.fee-radio-input:checked + .fee-option-content + .radio-indicator::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 8px;
  height: 8px;
  background: white;
  border-radius: 50%;
}

.fee-option-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.fee-amount {
  font-size: 1.5rem;
  font-weight: 800;
  color: #059669;
}

.fee-title {
  color: #6b7280;
  font-weight: 600;
}

.radio-indicator {
  position: relative;
  width: 24px;
  height: 24px;
  border: 2px solid #d1d5db;
  border-radius: 50%;
  transition: all 0.3s ease;
}

/* === 表單欄位 === */
.form-fields-container {
  display: grid;
  gap: 32px;
}

.form-field-card {
  padding: 24px;
  background: #fefefe !important;
  border-radius: 20px;
  border: 1px solid #f0e6eb;
}

.field-label {
  display: block;
  margin-bottom: 12px;
  font-weight: 700;
  color: #374151;
  font-size: 1.1rem;
}

/* 文字輸入 */
.input-wrapper {
  position: relative;
  width: 100%;
}

.modern-text-input {
  width: 100%;
  max-width: 100%;
  padding: 16px 20px;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  font-size: 1rem;
  transition: all 0.3s ease;
  background: white;
  box-sizing: border-box;
}

.modern-text-input:focus {
  outline: none;
  border-color: #10b981;
  box-shadow: 0 0 0 4px rgba(16, 185, 129, 0.1);
}

.modern-text-input:read-only {
  background: #f1f5f9;
  color: #64748b;
}

/* 選擇組 */
.choice-options-grid {
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
}

.choice-option-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: white;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.choice-option-card:hover {
  border-color: #d1d5db;
  background: #f9fafb;
}

.choice-input {
  accent-color: #10b981;
}

.choice-label {
  font-weight: 600;
  color: #374151;
}

/* 下拉選單 */
.select-wrapper {
  position: relative;
  width: 100%;
}

.modern-select-input {
  width: 100%;
  max-width: 100%;
  padding: 16px 50px 16px 20px;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  font-size: 1rem;
  background: white;
  cursor: pointer;
  transition: all 0.3s ease;
  appearance: none;
  box-sizing: border-box;
}

.modern-select-input:focus {
  outline: none;
  border-color: #10b981;
  box-shadow: 0 0 0 4px rgba(16, 185, 129, 0.1);
}

.select-arrow {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  color: #6b7280;
}

/* === 提交區域 === */
.submit-section {
  margin-top: 40px;
}

.modern-submit-btn {
  width: 100%;
  padding: 20px 40px;
  background: linear-gradient(135deg, #10b981, #059669);
  color: white;
  border: none;
  border-radius: 16px;
  font-size: 1.3rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  min-height: 72px;
  box-shadow: 0 8px 16px rgba(16, 185, 129, 0.3);
}

.modern-submit-btn:hover:not(:disabled) {
  transform: translateY(-4px);
  box-shadow: 0 16px 32px rgba(16, 185, 129, 0.4);
}

.modern-submit-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}

.submit-loading,
.submit-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
}

.submit-spinner {
  width: 24px;
  height: 24px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top: 2px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

/* === 響應式設計 === */
@media (max-width: 768px) {
  .modern-registration-app {
    padding: 0;
  }
  
  .registration-wrapper {
    margin: 0;
    padding: 0;
  }
  
  .modern-form {
    gap: 16px;
    padding: 12px;
  }
  
  .activity-hero-card,
  .activity-info-section,
  .calendar-selection-section,
  .selected-dates-section,
  .full-courses-alert,
  .registration-form-section {
    padding: 16px;
    margin-bottom: 0;
    border-radius: 16px;
  }
  
  .hero-image-container {
    height: 250px;
  }
  
  .activity-title {
    font-size: 2rem;
  }
  
  .section-title {
    margin-bottom: 20px;
  }
  
  .section-title h2 {
    font-size: 1.8rem;
  }
  
  .info-cards-grid {
    grid-template-columns: 1fr;
    gap: 12px;
    margin-bottom: 20px;
  }
  
  .selected-dates-container,
  .fee-options-grid,
  .choice-options-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  
  .form-fields-container {
    gap: 20px;
  }
  
  .fee-selection-card {
    padding: 16px;
    margin-bottom: 20px;
  }
  
  .fee-header {
    margin-bottom: 16px;
  }
  
  .form-field-card {
    padding: 16px;
  }
  
  .select-all-section {
    padding-top: 20px;
  }
  
  .submit-section {
    margin-top: 20px;
  }
}

/* === 保留原有日曆樣式 === */
.notes {
  position: absolute;
  border-radius: 15px;
  top: 25%;
  left: 0;
  width: 95%;
  height: 70%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  cursor: pointer;
  padding: 1rem;
  margin-left: 0.2rem;
  background-image: linear-gradient(to bottom, #f0fdf4, #10b981);
}

.notes p {
  margin: 0;
  font-size: 1rem;
  font-weight: bold;
  color: aliceblue;
}
</style>

<style>
.ant-fullcalendar-header{
  padding:10px;
  margin-top:-10px;
}
.ant-fullcalendar-header .ant-radio-group {
    display: none !important;
}
.ant-fullcalendar-year-select{
    padding:5px;
}
.ant-fullcalendar-month-select{
      left: -3px;
}
.ant-fullcalendar{
  font-size:12px;
  font-weight: bold;
}
</style>